import { focusRingStyle, paddingStyle } from "./styles.mjs";
import { Text, useTextStyles } from "./Text.mjs";
import { useTheme } from "./ThemeProvider.mjs";
import { useStyles } from "purse-styles";
import { Input as Input$1, Label, TextField as TextField$1 } from "react-aria-components";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/TextField.tsx
function TextField({ "aria-label": ariaLabel, label, background = "sandA2", placeholder, style: style$1, value, onChange, onBlur, onKeyDown, outlineWhenNonEmpty = false, subtlePlaceholder = true, error, type, autoComplete, isDisabled }) {
	const theme = useTheme();
	const textClassName = useTextStyles({ size: "sm" });
	const inputStyles = useStyles(paddingStyle({
		horizontal: "sm",
		vertical: "xs"
	}), focusRingStyle({
		theme,
		includeFocused: true
	}), outlineWhenNonEmpty && value ? { boxShadow: `0 0 0 2px ${theme.colors.accentA6}` } : {}, {
		flex: 1,
		background: theme.colors[background],
		borderRadius: theme.borderRadiuses["md"],
		border: "none",
		boxShadow: theme.shadows.subtle,
		["&::placeholder"]: {
			color: theme.colors.sand10,
			...subtlePlaceholder && {
				fontStyle: "italic",
				opacity: .8
			}
		}
	});
	return /* @__PURE__ */ jsxs(TextField$1, {
		"aria-label": ariaLabel,
		type,
		isDisabled,
		isInvalid: Boolean(error),
		style: {
			flex: 1,
			minWidth: 0,
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing.sm,
			...style$1
		},
		children: [
			label && /* @__PURE__ */ jsx(Label, { children: /* @__PURE__ */ jsx(Text, {
				size: "sm",
				light: true,
				weight: "medium",
				children: label
			}) }),
			/* @__PURE__ */ jsx(Input$1, {
				value,
				onChange,
				onBlur,
				onKeyDown,
				placeholder,
				autoComplete,
				className: textClassName + " " + inputStyles
			}),
			error && /* @__PURE__ */ jsx(Text, {
				size: "sm",
				color: "red11",
				children: error
			})
		]
	});
}
function Input({ size, weight, value, defaultValue, onChange, onBlur, onKeyDown, placeholder, style: style$1, autoFocus }) {
	return /* @__PURE__ */ jsx(Input$1, {
		value,
		defaultValue,
		onChange,
		onBlur,
		onKeyDown,
		placeholder,
		className: useTextStyles({
			size,
			weight
		}),
		autoFocus,
		style: {
			background: "transparent",
			border: "none",
			outline: "none",
			...style$1
		}
	});
}

//#endregion
export { Input, TextField };